import React from "react";
import StatusBadge from "../StatusBadge/StatusBadge";
import { resolveJobberStatusDisplay } from "../StatusBadge/jobberToneMap";

/** Style guide §6 — wraps shared `StatusBadge`; `change` / `converted` keep Jobber pill CSS. */
export const JobberStatusBadge = ({ children, tone = "neutral" }) => {
  const r = resolveJobberStatusDisplay(tone);
  if (r.kind === "legacy") {
    return (
      <span className={`jobber-status-pill jobber-status-pill--${r.tone}`}>
        {children}
      </span>
    );
  }
  return <StatusBadge variant={r.variant}>{children}</StatusBadge>;
};

/**
 * Maps API status strings to JobberStatusBadge tone (CSS: jobber-status-pill--*).
 */
export const getJobberStatusTone = (status) => {
  const raw = status == null ? "" : String(status).trim();
  if (!raw) return "neutral";
  const s = raw.toLowerCase();
  if (s === "converted") return "converted";
  if (["change requested", "changes requested", "request changed"].includes(s))
    return "change";
  if (s === "unscheduled") return "unscheduled";
  if (s === "past due") return "unpaid";
  if (s === "sent") return "scheduled";
  if (
    ["unpaid", "overdue", "canceled", "cancelled", "declined", "rejected", "failed", "void"].includes(s)
  ) {
    return "unpaid";
  }
  if (
    ["active", "approved", "paid", "today", "upcoming", "completed"].includes(s)
  ) {
    return "active";
  }
  if (["scheduled", "awaiting response"].includes(s)) {
    return "scheduled";
  }
  if (["partial", "partially paid", "partial paid"].includes(s)) {
    return "unscheduled";
  }
  if (["draft", "inactive", "deactive"].includes(s)) {
    return "inactive";
  }
  return "neutral";
};

/**
 * Visit/appointment list labels only (worker & customer appointment tables).
 * Uses distinct Jobber pills without changing {@link getJobberStatusTone} for invoices, quotes, or contracts.
 */
export const getVisitAppointmentStatusTone = (status) => {
  const raw = status == null ? "" : String(status).trim();
  if (!raw) return "neutral";
  const s = raw.toLowerCase();
  if (s === "late") return "unpaid";
  if (s === "today") return "scheduled";
  if (s === "upcoming") return "unscheduled";
  if (s === "confirmed") return "active";
  if (s === "scheduled") return "scheduled";
  if (s === "completed") return "active";
  return getJobberStatusTone(status);
};

/**
 * Customer contract list only (job lifecycle: Today / Upcoming / Scheduled / Converted / Unscheduled).
 * Distinct pills without changing {@link getJobberStatusTone} for admin contract tables.
 */
export const getCustomerContractListStatusTone = (status) => {
  const raw = status == null ? "" : String(status).trim();
  if (!raw) return "neutral";
  const s = raw.toLowerCase();
  if (s === "today") return "scheduled";
  if (s === "upcoming") return "unscheduled";
  if (s === "converted") return "converted";
  if (s === "scheduled") return "scheduled";
  if (s === "unscheduled") return "unscheduled";
  return getJobberStatusTone(status);
};
